var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"text-yellow"},[_vm._v(" ! Página no encontrada. ")])}
var staticRenderFns = []

export { render, staticRenderFns }